
import { ready } from "./utils.js";
import $ from "jquery";
import "jquery.scrollto";

ready(() => {
  const totopbutton = document.getElementById("totopbutton");

  function updateScrollClasses() {
    const scrollY = window.scrollY;
    if (scrollY > 300) {
      totopbutton.classList.add("visible");
    } else if (scrollY < 10) {
      totopbutton.classList.remove("visible");
    }
  }
  
  if (totopbutton) {
    document.addEventListener("scroll", updateScrollClasses); //on scroll
    updateScrollClasses(); //after reload

    totopbutton.addEventListener("click", function() {
        $(window).scrollTo(0, 1000);
    });
  }
});
